import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

const styles = theme => ({
  inputContainer: {
    marginBottom: theme.spacing(2)
  },
  inputLabelOverride: {
    display: "inline-block",
    marginBottom: theme.spacing(1),
    color: "#333"
  },
  inputOverride: {
    border: "1px solid #9B9B9B",
    borderRadius: 5,
    padding: [[theme.spacing(0.5), theme.spacing(2)]],
    width: "100%"
  },
  inputErrorOverride: {
    border: "1px solid #ff5555"
  }
});

class OSSTextInput extends React.Component {
  render() {
    const { classes, gutterBottom, label, errors, required, ...rest } =
      this.props;

    const hasErrors = !!(errors && errors.length);

    return (
      <span className={gutterBottom ? classes.inputContainer : ""}>
        <InputLabel
          required={required}
          classes={{
            root: classes.inputLabelOverride
          }}
        >
          {label}
        </InputLabel>
        <Input
          error={hasErrors}
          required={required}
          {...rest}
          classes={{
            root: classes.inputOverride,
            error: classes.inputErrorOverride
          }}
          disableUnderline={true}
        />
        {hasErrors &&
          errors.map((error, index) => (
            <FormHelperText key={index} error>
              {error}
            </FormHelperText>
          ))}
      </span>
    );
  }
}

OSSTextInput.propTypes = {
  label: PropTypes.string,
  gutterBottom: PropTypes.bool
};

OSSTextInput.defaultProps = {
  gutterBottom: true
};

export default withStyles(styles)(OSSTextInput);
